// Account Authentication

<template>
<div class="lms2020 container white curved">

  <div class="board">
    <Ul class="crumbs text-charcoal mb-2">
      <li><sym-link to="/">Home</sym-link></li>
      <li><sym-link to="lms1030">Portal</sym-link></li>
      <li><span aria-current="page">Account Authentication</span></li>
    </Ul>

    <div class="page-title lams curved border-lightgray mb-4">
      <h5 class="serif mb-0"><i class="fa fa-drivers-license-o fa-lg ml-1 mr-2"></i>Account Authentication</h5>
    </div>

    <sym-alert class="beige border-main lg-2" icon="thumbs-o-up" dismissible v-show="availableRegions.length">
      <p class="mb-1">Have your account recognized by region by uploading the eSurveyPlan license(s) issued to you: </p>

      <p class="mb-0">These regions are ready to accept your upload: </p>
      <hr class="separator">
      <ul class="avl-regions mb-2">
        <li v-for="region in availableRegions" :key="region.regionId"><b>{{ region.regionFullName }}</b></li>
      </ul>
    </sym-alert>

    <sym-upload
      class="lams-light border-main curved-1 p-1 shadow-soft"
      inputClass="lams-light shadow"
      uploadButtonClass="success shadow"
      resetButtonClass="danger-light border-main shadow-light"
      iconClass="fa-file-o fa-fw fa-3x"
      :multiple="false"
      accept=".xml"
      instructions="Drag <span class='bold'>License file</span> here <br>or click to browse"
      uploadButtonText="Click to Upload Now"
      :blinkUploadIcon="true"
      @upload="onUploadLicense"
    >
    </sym-upload>

    <button type="button" class="primary text-center w-100 lg-1 shadow mt-3" @click="go('lms1030')"><i class="fa fa-arrow-left mr-2"></i> Back to GE Portal </button>

  </div>

</div>
</template>

<script>

import
  * as lams
from '../../js/lams';

import {
  upload
} from '../../js/http';

import
  PageBase
from '../PageBase.vue';

export default {
  extends: PageBase,
  name: 'lms2020',

  data () {
    return {
      availableRegions: []
    };
  },

  methods: {

    // API calls

    uploadLicense (files) {
      return upload('api/accounts/' + this.accountCode + '/authentication' , files);
    },

    // event handlers

    onUploadLicense (e) {
      const me = this;

      let wait = me.wait();

      me.uploadLicense(e.fileList)
        .then( info => {
          me.stopWait(wait);

          // e.reset();
          // e.showUploadResponse(info)
          //   .then( () => {
          //     // me.loadData();
          //   });

          e.reset();
          if (info.createdCount) {
            let html = "Your account is now recognized as Geodetic Engineer by region (" + info.details[0].statusText + ")";
            me.dialog.success(html);
          } else {
            me.dialog.fault(info.details[0].statusText);
          }

        })
        .catch( fault => {
          me.stopWait(wait);
          e.reset();
          me.showFault(fault);
        });

    },

  },

  created () {
    this.accountCode = '';
  },

  mounted () {
    const me = this;

    me.accountCode = me.sym.userInfo.accountCode,
    me.availableRegions = lams.getRegionList().filter(o => o.apiHostAddress);

  }


}

</script>

<style scoped>

/* .lms2020 {
  min-height: calc(100vh - 90px - 2rem) ;
} */

.page-title {
  padding: .875rem;
}

.avl-regions {
  display: grid;
  gap: 1rem;
  grid-template-columns: repeat(3, 1fr);
}

.avl-regions li {
  margin-left: 1.25rem;
  line-height: .5;
}

.separator {
  margin-bottom: 1rem;
}

.alert.fade-enter-active {
  transition: opacity 1s;
}

.alert.fade-leave-active {
  transition: opacity .5s;
}

@media (max-width: 1048px) {
  .avl-regions {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 650px) {
  .avl-regions {
    grid-template-columns: 1fr;
  }
}

/* @media (max-width: 576px) {
  .lms2020 {
    min-height: calc(100vh - 84px) ;
  }
} */

@media (max-width: 480px) {
  .page-title {
    padding: .6875rem;
  }
}

@media (max-width: 384px) {
  .page-title {
    padding: .5rem;
  }
}

</style>